import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  TestSeriesListLoading: false,
  TestSeriesList: {},
  TestSeriesListError: null,

  TestSeriesByIdLoading: false,
  TestSeriesByIdSuccess: {},
  TestSeriesByIdError: "",
}

export const testSeriesSlice = createSlice({
  name: 'testSeries',
  initialState,
  reducers: {
    getTestSeriesListLoading: (state, action) => {
      state.TestSeriesListLoading = true
    },
    getTestSeriesListSuccess: (state, action) => {
      state.TestSeriesListLoading = false
      state.TestSeriesList = action.payload
    },

    getTestSeriesListError: (state, action) => {
      state.TestSeriesListLoading = false
      state.TestSeriesList = {}
      state.TestSeriesListError = action.payload.message
    },
    getTestSeriesByIdLoading: (state, action) => {
      state.TestSeriesByIdLoading = true


    },
    getTestSeriesByIdSuccess: (state, action) => {
      state.TestSeriesByIdLoading = false
      state.TestSeriesByIdSuccess = action.payload.data
      state.TestSeriesByIdError = ""

    },
    getTestSeriesByIdError: (state, action) => {
      state.TestSeriesByIdLoading = false
      state.TestSeriesByIdSuccess = {}
      state.TestSeriesByIdError = action.payload.message


    },
    resetTestSeriesDetails: (state, action) => {
      state.TestSeriesByIdLoading = false
      state.TestSeriesByIdSuccess = {}

    },
  },
})

// Action creators are generated for each case reducer function
export const {
  getTestSeriesListLoading,
  getTestSeriesListSuccess,
  getTestSeriesListError,
  getTestSeriesByIdLoading,
  getTestSeriesByIdSuccess,
  getTestSeriesByIdError,
  resetTestSeriesDetails,
} = testSeriesSlice.actions

export default testSeriesSlice.reducer;